import React from 'react';

import { Helpers } from '../../core/src/helpers';
import useDeals from '../../hooks/useDeals';

const getSortedProducts = Helpers.memoize(
    (key, products, deals) => {
        const { activeDeals } = deals || {};
        if (!activeDeals || Object.keys(activeDeals).length < 1) return null;
        //create a list of products with deals sorted by highest discountPercent
        const dealsList = Object.keys(activeDeals)
            .map(key => activeDeals[key])
            .sort((a, b) => b.discountPercent - a.discountPercent);

        //copy the products array to avoid mutating the original array. Exclude UDF tiles from the copy and products in the dealsList
        const sortedProducts = products
            .slice()
            .filter(
                product =>
                    product?.sku?.indexOf('USER_DEFINED') === -1 &&
                    !dealsList.find(deal => deal.itemId === Helpers.getCatEntryId(product)),
            );
        //move products from deallist into even positions in the sortedProducts array starting at 0
        dealsList.forEach((deal, i) => {
            const index = i * 2;
            const product = products.find(product => deal.itemId === Helpers.getCatEntryId(product));
            //insert the product into the sortedProducts array at the correct index
            sortedProducts.splice(index, 0, product);
        });
        //return UDF tiles to their original positions
        products.forEach((product, i) => {
            if (product?.sku?.indexOf('USER_DEFINED') > -1) {
                //insert the product into the sortedProducts array at it's original index
                sortedProducts.splice(i, 0, product);
            }
        });
        return sortedProducts;
    },
    (key, products, deals) => {
        return `${key}-${products?.length}-${deals?.length}`;
    },
);

export default ({ children, ...restProps }) => {
    const { productGroup } = restProps;
    const { productsList, products, metaData, key } = productGroup || {};
    const derivedProductList = products || productsList;
    const { intraDayDealSort } = metaData || {};
    const deals = useDeals(derivedProductList);

    const dealsSortedProducts = intraDayDealSort ? getSortedProducts(key, derivedProductList, deals) : null;
    return children({ dealsSortedProducts });
};
